import React, { useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ToolBarContext } from '../../../App';

const alerts = {
  invalidMeeting: {
    title: 'Invalid Meeting Link',
    description: 'The Meeting link is invalid, please join with valid Meeting link',
  },
  meetingEnded: {
    title: 'Meeting Ended',
    description: 'The Meeting has been Ended by the Host',
  },
  meetingExpiredhost: {
    title: 'Meeting Expired',
    description: 'The Meeting link has been Expired. Please create a new meeting to continue.',
  },
  meetingExpiredguest: {
    title: 'Meeting Expired',
    description: 'The Meeting link has been Expired.',
  },
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      color: '#3498DB',
    },
  })
);

function AlertDialog({ alertType }) {
  const [open, setOpen] = React.useState(true);
  const classes = useStyles();
  const { setMeetingEnded } = useContext(ToolBarContext);

  const handleAlert = () => {
    setMeetingEnded(true);
    setOpen(!open);
  };

  return (
    <Dialog open={open} fullWidth={true} maxWidth="xs">
      <DialogTitle>{alerts[alertType].title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{alerts[alertType].description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAlert} className={classes.button} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialog;
